import DisplayRetail from '../../display-retail';

const ViMarcStackAdapt = (props) => (
    <DisplayRetail {...props} />
);

export default ViMarcStackAdapt;
